export var Role;
(function (Role) {
    Role["ADMIN"] = "admin";
    Role["PARTNER"] = "partner";
    Role["HOST"] = "host";
    Role["MODERATOR"] = "moderator";
    Role["VIP"] = "vip";
    Role["USER"] = "user";
})(Role || (Role = {}));
